import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceMessageModel } from '../models/maintenanceMessage.model';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceMessageService {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);

  getMaintenanceMessage(): Observable<MaintenanceMessageModel> {
    return this._http
      .get<MaintenanceMessageModel>(this.__URL_API__ + 'api/MaintenanceMessages/ecli')
      .pipe(catchError((error) => this.handleError(error)));
  }
  private handleError(error: any): Observable<never> {
    return throwError(() => error.message || error);
  }
}
